<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button size="large" (click)="AddNew()"><ion-icon slot="icon-only" name="add-outline"
          style="font-size: 38px"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Exercises</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid>
    <ion-row *ngIf="!isLoading">
      <ion-col sizeXl="10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="filterExercises()">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && loadedExercises.length===0">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">You have not added any exercises yet. <br />
    </ion-text>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list *ngIf="!isLoading && loadedExercises.length>0" color="lightmimbo">
          <ion-item-sliding color="lightmimbo" *ngFor="let exercise of loadedExercises">
            <ion-item detail button="true" color="lightmimbo" (click)="ViewExercise(exercise.id)">
              <img [src]="exercise.thumbnailImage" class="avatar" />
              <div style="padding-bottom: 12px; padding-top: 12px">
                <h1>{{exercise.name}}</h1>
                <h6>{{exercise.goal}}</h6>
              </div>
            </ion-item>
            <ion-item-options>
              <ion-item-option color="danger" (click)="deleteExercise(exercise.id)"><ion-icon name="trash-outline"
                  slot="start"></ion-icon>Delete</ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-list></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-modal class="full-ion-modal" [isOpen]="isModalOpen" #newExerciseModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()"><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon></ion-button>
        </ion-buttons>
        <ion-title>Add/Update Exercise</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" color="lightmimbo" *ngIf="isPreviewMode == false">
      <form #f="ngForm" class="ion-padding" (ngSubmit)="previewExercise()">
        <ion-grid>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Name" required [(ngModel)]="selectedName" name="nameCtrl" labelPlacement="floating"
                  placeholder="Enter Exercise Name"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-select required name="petTypeCtrl" label="Pet Type*" labelPlacement="floating"
                  interface="action-sheet" [(ngModel)]="selectedPetTypeId">
                  <ion-select-option [value]="1">Dogs</ion-select-option>
                  <ion-select-option [value]="2">Cats</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input required label="Exercise Goal" name="goalCtrl" [(ngModel)]="selectedGoal"
                  labelPlacement="floating" placeholder="Enter Exercise Goal"></ion-input>
              </ion-item> </ion-col></ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input required label="Video URL" name="urlCtrl" [(ngModel)]="selectedUrl" labelPlacement="floating"
                  placeholder="Enter Video URL"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea rows="5" name="descCtrl" required autoGrow="true" [(ngModel)]="selectedDesc"
                  placeholder="Enter Exercise Description...">
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="!isUpdate">
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-checkbox name="notifCtrl" #chkNotif [(ngModel)]="sendNotif">
                  Send Notification
                </ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="lightmimbo">
                <div>
                  <app-image-picker (photoCaptured)="onPhotoCaptured($event)"></app-image-picker>
                  <br />
                  <small>
                    <ion-text color="success" style="display: block" *ngIf="uploadedImage.length>0">Image Uploaded
                      Successfully</ion-text>
                    <ion-text color="danger" style="display: block"
                      *ngIf="showImageError && uploadedImage.length==0">You need to upload an image to
                      continue</ion-text>
                  </small>
                </div>
              </ion-item>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="6" offsetXl="3" class="ion-text-center">
              <ion-button type="submit" [disabled]="!f.valid"><ion-icon name="eye-outline" slot="start"></ion-icon>
                Preview Exercise
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-content>
    <ion-content *ngIf="isPreviewMode == true" color="lightmimbo">
      <ion-grid>
        <ion-row *ngIf="!isUpdate">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="6" offsetXl="3" class="ion-text-center">
            <ion-text *ngIf="sendNotif" color="success" class="notif-label"><ion-icon
                name="checkmark-outline"></ion-icon>A NOTIFICATION WILL
              BE SENT</ion-text>
            <ion-text *ngIf="!sendNotif" color="danger" class="notif-label">
              <ion-icon name="close-outline"></ion-icon>A NOTIFICATION WILL NOT
              BE SENT</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="6" offsetXl="3">
            <ion-item color="lightmimbo">
              <img [src]="uploadedImage" class="avatar" />
              <div>
                <h1>{{selectedName}}</h1>
                <h6>{{selectedGoal}}</h6>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="6" offsetXl="3">
            <ion-item color="lightmimbo">
              <div class="video-container">
                <iframe width="100%" height="315" [src]="trustedLink" title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="desc" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <div class="ion-text-center follow">Follow These Steps</div>
            <div [innerHTML]="newDirections"></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="6" offsetXl="3" class="ion-text-center">
            <ion-button (click)="AddExercise()" *ngIf="!isUpdate"><ion-icon name="save-outline"
                slot="start"></ion-icon>Add
              Exercise</ion-button>
            <ion-button (click)="UpdateExercise()" *ngIf="isUpdate"><ion-icon name="save-outline"
                slot="start"></ion-icon>Update
              Exercise</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>